import React from 'react';
interface StarRatingProps {
  rating: number;
  hideText?: boolean;
}

const formatRating = (rating: number): string => {
  if (!Number.isFinite(rating)) return '0';
  const rounded = Math.round(rating * 10) / 10;
  return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
};

const StarRating: React.FC<StarRatingProps> = ({ rating, hideText = false }) => {
  const fullStars = Math.floor(rating);
  const fraction = rating - fullStars;
  // With 1-decimal ratings, only show half-star when >= 0.5
  const hasHalfStar = fraction >= 0.5;
  const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

  return (
    <div className={`flex items-center star-rating`}>
      {Array.from({ length: fullStars }).map((_, i) => (
        <span key={`full-${i}`} className="star-full">★</span>
      ))}
      {hasHalfStar && <span className="star-half">★</span>}
      {Array.from({ length: emptyStars }).map((_, i) => (
        <span key={`empty-${i}`} className="star-empty">★</span>
      ))}
      {!hideText && <span className="rating-text">{formatRating(rating)}/5</span>}
    </div>
  );
};

export default StarRating;

